module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Reigoldswil-d71021967d7e171ea36b9c360d905d94.png";